import React from "react"
import { Link as RouterLink } from "react-router-dom"
import { Box, Breadcrumb, Breadcrumbs } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Paths } from "#/utils/Paths"
import { helpCenterCategoryPath } from "#/services/help-center/urls"
import { faqsLabelMessage } from "#/pages/faqs/messages"

type FaqsBreadcrumbsProps = {
  category?: {
    title: string
    slug: string
    currentPage?: boolean
  }
}

export function FaqsBreadcrumbs({ category }: FaqsBreadcrumbsProps): JSX.Element {
  return (
    <Box sx={(theme) => ({ paddingBlockEnd: theme.spacing(theme.tokens.spacing.sm) })}>
      <Breadcrumbs>
        <Breadcrumb component={RouterLink} to={Paths.FAQS}>
          <FormattedMessage {...faqsLabelMessage} />
        </Breadcrumb>
        {category ? (
          category.currentPage ? (
            <Breadcrumb currentPage>{category.title}</Breadcrumb>
          ) : (
            <Breadcrumb component={RouterLink} to={helpCenterCategoryPath(category.slug)}>
              {category.title}
            </Breadcrumb>
          )
        ) : null}
      </Breadcrumbs>
    </Box>
  )
}
